import { Button, Progress } from 'antd';
import styled, { css } from 'styled-components';
import { devices } from '../../const/devices';

export const FooterButton = styled(Button)`
	flex: 1;
	height: auto;
	padding: 0.5rem 1rem;
`;

export const ArrowRight = styled.img`
	position: absolute;
	right: 20px;
	bottom: 20px;
`;

export const NoStyleButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	cursor: pointer;
`;

export const Message = styled.p`
	margin: 0;
	padding: 0;
	text-align: left;
	font-size: 18px;
	font-weight: 500;
	max-width: 300px;
`;

export const YellowCircle = styled.div`
	position: absolute;
	top: -100px;
	left: -100px;
	width: 200px;
	height: 200px;
	background-color: #ebca53;
	border-radius: 50%;
	z-index: 3;
`;

export const TurquoiseCircle = styled.div`
	position: absolute;
	top: -90px;
	left: 30px;
	width: 155px;
	height: 155px;
	background-color: #53e8b3;
	border-radius: 50%;

	z-index: 2;
`;

export const BlueCircle = styled.div`
	position: absolute;
	top: -80px;
	right: -70px;
	width: 200px;
	height: 180px;
	background-color: #5a78bd;
	border-radius: 50%;

	z-index: 2;
`;

export const StyledProgress = styled(Progress)<{ $finished?: boolean }>`
	width: 100%;

	.ant-progress-steps-item {
		flex: 1;
		border-radius: 5px;
		${({ $finished }) => ($finished ? 'background-color: #FAAD14;' : '')}
	}
`;

export const StepperContainer = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	gap: 4px;

	align-items: flex-end;
`;

export const UpgradeMessageContainer = styled.div<{ $isWidget?: boolean; $hasArrow?: boolean }>`
	width: 100%;
	height: 200px;
	border-radius: 10px;
	border: 2px solid #c3af46;
	box-shadow: 0px 1.64px 4.92px 0px #0000001a;
	background-color: #fff;

	position: relative;
	padding: 20px;
	padding-right: ${({ $hasArrow }) => ($hasArrow ? '60px' : '20px')};
	display: flex;
	flex-direction: column;
	justify-content: flex-end;

	overflow: hidden;

	${({ $isWidget }) =>
		$isWidget &&
		css`
			height: auto;
			padding: 0.5rem;
			border: none;
			padding-top: 50px;
			gap: 0.5rem;

			${Message} {
				font-size: 16px;
				line-height: 22px;
			}

			${FooterButton} {
				padding: 4px 0;
			}

			${StepperContainer} {
				margin-top: 0;
				align-items: flex-start;
				margin-bottom: 5px;
				gap: 2px;
			}

			${YellowCircle} {
				top: -140px;
				left: -140px;
			}

			${TurquoiseCircle} {
				top: -120px;
				left: -20px;
			}

			${BlueCircle} {
				top: -120px;
				right: -130px;
			}
		`}

	@media ${devices.tablet} {
		height: 150px;

		${YellowCircle} {
			top: -120px;
			left: -120px;
		}

		${TurquoiseCircle} {
			top: -110px;
			left: 20px;
		}

		${BlueCircle} {
			top: -120px;
			right: -100px;
		}
	}
`;

export const Description = styled.p`
	color: #595959;
	font-size: 15px;
	line-height: 18px;
	font-weight: 500;
	padding: 0;
	margin: 0;
`;
